import React, { useMemo } from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { MediaPreview } from "ui/MediaPreview"
import { Icon } from "ui/Icon"
import { colors } from "themes/variables"
import styles from "./MediaGrid.module.css"
import classNames from "classnames"
import { HeroImage } from "./HeroImage"
import PropTypes from "prop-types"
import { CropIcon } from "ui/Icon/DSIcon/CropIcon"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import { is } from "immutable"
const SortableMediaItem = ({ id, media, onImageClick, withActions, onDelete, onCrop, className, showHeroImageLabel = false }) => {
  const { t } = useTranslation()
  const location = useLocation();
  const isMedia = location.pathname.endsWith('/media') || location.pathname.endsWith('/resources');
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  }

  const mediaPreview = useMemo(() => {
    const mediaToUse = Array.isArray(media) ? media[0] : media;
    return <MediaPreview key={mediaToUse?.id} media={mediaToUse} onClick={() => onImageClick?.(mediaToUse)} lazyLoad={false} />
  }, [media, onImageClick])

  // Determine button text based on media type
  const mediaToCheck = Array.isArray(media) ? media[0] : media;
  const isVideo = mediaToCheck?.mediaType === "video" || mediaToCheck?.file_type === "video";
  const buttonText = isVideo
    ? t('media_grid.trim_button')
    : t('media_grid.crop_button');
  return (
    <div ref={setNodeRef} style={style} {...attributes} className={classNames("relative w-full", className)}>
      <div className="relative w-full h-full" {...listeners}>
        {mediaPreview}
        {isMedia && isVideo && (
          <button
            type="button"
            className={classNames(styles.actionWrapperCrop)}
            aria-label={buttonText}
            title={buttonText}
            onClick={(e) => {
              e.stopPropagation()
              onCrop?.(Array.isArray(media) ? media[0] : media)
            }}
            onPointerDown={(e) => {
              e.stopPropagation()
            }}
          >
            <CropIcon width={16} height={16} stroke={colors.textSecondary} />
          </button>
        )}

      </div>
      {withActions && (
        <button
          type="button"
          className={classNames(styles.actionWrapper)}
          aria-label={t("media_grid.remove_aria_label")}
          title={t("media_grid.remove_button")}
          onClick={(e) => {
            e.stopPropagation()
            onDelete?.(media)
          }}
          onPointerDown={(e) => {
            e.stopPropagation()
          }}
        >
          <Icon type="feather" name="X" width={16} height={16} strokeWidth={2} color={colors.textSecondary} />
        </button>
      )}
      {showHeroImageLabel && <HeroImage />}
    </div>
  )
}

SortableMediaItem.propTypes = {
  id: PropTypes.string.isRequired,
  media: PropTypes.object.isRequired,
  onImageClick: PropTypes.func,
  withActions: PropTypes.bool,
  onDelete: PropTypes.func,
  onCrop: PropTypes.func,
  className: PropTypes.string,
  showHeroImageLabel: PropTypes.bool,
}

export default SortableMediaItem
